module.exports = __webpack_public_path__ + "img/gallery_b.0ae8267d.svg";